class SiteConfig {
    /** 作者链接 */
    authorLink = 'https://github.com/1226085293';
    /** 项目 github 仓库 */
    projectGithubRepo = 'https://github.com/1226085293/MKFramework';
    /** 项目 gitee 仓库 */
    projectGiteeRepo = 'https://gitee.com/muzzik/MKFramework';
    /** cocos 帖子地址 */
    cocosPostUrl = 'https://forum.cocos.org/t/topic/159492';
    /** 站点仓库集合 */
    siteRepos: Record<string, string> = {
        github: 'https://github.com/1226085293/MKFrameworkDocs',
    };
    /** 项目 */
    projectsDiscussionUrl = 'https://github.com/1226085293/MKFrameworkDocs/discussions/3';
    /** 站点仓库 */
    repo = this.siteRepos.github;
    /** QQ 群信息 */
    qqGroupInfo = {
        link: 'https://qm.qq.com/q/l53vHThl3a',
        number: '348096019',
    };
    /** 赞助列表 */
    donateList: {
        avatar: string;
        name: string;
    }[] = [
        {
            avatar: 'https://q1.qlogo.cn/g?b=qq&nk=3548450021&s=640',
            name: 'Surprise',
        },
        {
            avatar: '/donate/avatar/QQ20251014-145523.png',
            name: '丁',
        },
        {
            avatar: '/donate/avatar/微信图片_2025-11-20_104641_695.jpg',
            name: '夏雨晴空',
        },
        {
            avatar: 'https://q1.qlogo.cn/g?b=qq&nk=3829030269&s=640',
            name: 'Mirror',
        },
        {
            avatar: 'https://q1.qlogo.cn/g?b=qq&nk=2771622571&s=640',
            name: '张鱼丸',
        },
        {
            avatar: "./donate/avatar/IMG_7577.jpg",
            name: '974',
        },
    ];
    /** 评论系统配置 */
    giscus = {
        repo: this.siteRepos.github.replace('https://github.com/', '') as `${string}/${string}`,
        repositoryId: process.env.NEXT_PUBLIC_GISCUS_REPOSITORY_ID as string,
        category: process.env.NEXT_PUBLIC_GISCUS_CATEGORY as string,
        categoryId: process.env.NEXT_PUBLIC_GISCUS_CATEGORY_ID as string,
    };
}

const siteConfig = new SiteConfig();

export default siteConfig;
